import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { PAYMENT_TYPES, GATEWAY_TYPES } from 'portal-modules/payments/constants/types'
import { CCCard, MoneyGramCard, SEPACard, PADCard, BACSPaymentCard } from './PaymentCards'
import { getPaymentMethodAccess } from 'portal-modules/payments/utils/getPaymentMethodAccess'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
const { isRH } = getProjectConditions()

const cardsMap = {
  4: PADCard,
  5: CCCard,
  6: CCCard,
  7: CCCard,
  8: CCCard,
  10: MoneyGramCard,
  13: SEPACard,
  14: PADCard,
  20: CCCard,
  22: BACSPaymentCard,
}

const PaymentMethods = props => {
  const {
    id,
    payment_type_id,
    autoPayments,
    setState,
    refundMethods,
    updateAllowed,
    onDeleteWithPaymentsAndRefundAccount,
    onDeleteWithPayments,
    onDeleteWithRefundAccount,
    onDelete,
    isRefundAccount,
    isAddAutoPaymentAllowed,
    isEditAutoPaymentAllowed,
    isDeleteAutoPaymentAllowed,
    deletePaymentMethodAccess,
    editPaymentMethodAccess,
    addPaymentMethodAccess,
    isScreeningEnabled,
    isScreeningValidationEnabled,
    gateway_provider,
    ...rest
  } = props

  const connectedAutoPayments =
    (autoPayments.length &&
      autoPayments.filter(
        autoPayment =>
          autoPayment.customer_payment_account_id == id && autoPayment,
      )) ||
    []

  const hasRefundAccount =
    !!refundMethods.length &&
    (refundMethods[0].payment_account_id == id ||
      refundMethods[0].customer_payment_account_id == id ||
      refundMethods[0].id == id)

  const CardType = cardsMap[payment_type_id]

  const { bank_info } = rest
  // if disable_flex_payment_account exists in the rest uses its value otherwise return false
  const disableFlexPaymentAccount = ( rest.disable_flex_payment_account ?? false );

  const isConfirmMicroDeposit = !!(
    PAYMENT_TYPES.ECHECK.value == payment_type_id &&
    bank_info &&
    bank_info.plaid_verification_status == 'pending_manual_verification'
  )

  const handleDelete = () => {
    if (connectedAutoPayments && connectedAutoPayments.length) {
      hasRefundAccount
        ? onDeleteWithPaymentsAndRefundAccount(id)
        : onDeleteWithPayments(id)
    } else {
      hasRefundAccount && props.isFromWallet
        ? onDeleteWithRefundAccount(id)
        : onDelete(id)
    }
  }

  const handleEdit = () => {
    if (isConfirmMicroDeposit && id) {
      setState(state => ({
        ...state,
        isLaunchPlaid: true,
        plaidPaymentAccountId: id,
        isPlaidConfirmMicroDeposit: isConfirmMicroDeposit,
      }))
    } else {
      props.onEdit(id, payment_type_id)
    }
  }

  const canUpdateAllowed =
    connectedAutoPayments && connectedAutoPayments.length && !updateAllowed
      ? false
      : true
  return (
    CardType ? (
      <CardType
        {...rest}
        onDelete={(canUpdateAllowed && handleDelete) || (() => {})}
        onEdit={props.onEdit && canUpdateAllowed ? handleEdit : null}
        paymentTypeId={payment_type_id}
        connectedAutoPayments={connectedAutoPayments}
        hasRefundAccount={hasRefundAccount}
        isRefundAccount={isRefundAccount}
        id={id}
        isAddAutoPaymentAllowed={isAddAutoPaymentAllowed}
        isEditAutoPaymentAllowed={isEditAutoPaymentAllowed}
        isDeleteAutoPaymentAllowed={isDeleteAutoPaymentAllowed}
        deletePaymentMethodAccess={deletePaymentMethodAccess}
        editPaymentMethodAccess={editPaymentMethodAccess}
        addPaymentMethodAccess={addPaymentMethodAccess}
        isScreeningEnabled={isScreeningEnabled}
        isScreeningValidationEnabled={isScreeningValidationEnabled}
        disableFlexPaymentAccount={disableFlexPaymentAccount}
        gatewayProvider={gateway_provider}
      />
    ) : <></>
  )
}

PaymentMethods.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  payment_type_id: PropTypes.number,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  autoPayments: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  refundMethods: PropTypes.arrayOf(PropTypes.object),
  updateAllowed: PropTypes.bool,
  onDeleteWithPaymentsAndRefundAccount: PropTypes.func,
  onDeleteWithPayments: PropTypes.func,
  onDeleteWithRefundAccount: PropTypes.func,
  deletePaymentMethodAccess: PropTypes.bool,
  editPaymentMethodAccess: PropTypes.bool,
  addPaymentMethodAccess: PropTypes.bool,
  isScreeningEnabled: PropTypes.bool,
  isScreeningValidationEnabled: PropTypes.bool,
}

export default connect(
  ({
    autoPayments,
    refundMethod,
    settings: { scheduledPayments, paymentMethods, payments },
    productPermissions
  }) => ({
    autoPayments: Object.values(autoPayments) || {},
    refundMethods: Object.values(refundMethod) || [],
    isAddAutoPaymentAllowed:
      scheduledPayments?.scheduled_payment_permissions?.includes('add') ||
      false,
    isEditAutoPaymentAllowed:
      scheduledPayments?.scheduled_payment_permissions?.includes('edit') ||
      false,
    isDeleteAutoPaymentAllowed:
      scheduledPayments?.scheduled_payment_permissions?.includes('delete') ||
      false,
    deletePaymentMethodAccess: getPaymentMethodAccess('delete', paymentMethods),
    editPaymentMethodAccess: getPaymentMethodAccess('edit', paymentMethods),
    addPaymentMethodAccess: getPaymentMethodAccess('add', paymentMethods),
    isScreeningEnabled: isRH
      ? productPermissions?.is_screening_enabled || false
      : payments?.is_screening_enabled || false,
    isScreeningValidationEnabled: isRH
      ? productPermissions?.is_screening_validation_enabled || false
      : payments?.is_screening_validation_enabled || false,
    gateway_provider: payments?.gateway_provider|| GATEWAY_TYPES.WORLDPAY.value,  
  }),
)(PaymentMethods)
